import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import App from './App';
import NotFound from './pages/404';
import Forbidden from './pages/Forbidden';
import DashboardPage from './pages/DashboardPage';
import ChartOfAccountsPage from './pages/ChartOfAccountsPage';
import JournalEntriesPage from './pages/JournalEntriesPage';
import TrialBalancePage from './pages/TrialBalancePage';
import GeneralLedgerPage from './pages/GeneralLedgerPage';
import IncomeStatementPage from './pages/IncomeStatementPage';
import AccountingSettingsPage from './pages/AccountingSettingsPage';
import TreasuryPage from './pages/TreasuryPage';
import { contentPath, modules } from './config/const';
import React from 'react';

function Routes() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={App} />
        <Route exact path="/sorry" component={Forbidden} />
        <Route exact path={contentPath[modules.Dashboard]} component={DashboardPage} />
        <Route exact path={contentPath[modules.ChartOfAccounts]} component={ChartOfAccountsPage} />
        <Route exact path={contentPath[modules.JournalEntries]} component={JournalEntriesPage} />
        <Route exact path={contentPath[modules.TrialBalance]} component={TrialBalancePage} />
        <Route exact path={contentPath[modules.GeneralLedger]} component={GeneralLedgerPage} />
        <Route exact path={contentPath[modules.IncomeStatement]} component={IncomeStatementPage} />
        <Route exact path={contentPath[modules.AccountingSettings]} component={AccountingSettingsPage} />
        <Route exact path={contentPath[modules.Treasury]} component={TreasuryPage} />
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
}

export default Routes;
